import React, { useState, useRef } from "react";
import { Grid, IconButton, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import SimpleDialog from "../../../SimpleDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Filter from "../../../Filter";

const NoHeaderDataGrid = styled(DataGrid)(({ }) => ({ "& .MuiDataGrid-columnHeaders": { display: "none" }, "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" } }));

const UsersTab = ({ centerUsers }) => {


    const [filter, setFilter] = useState("");
    const [activeFilter, setActiveFilter] = useState(true);

    const searchBarHelper = "Search for a user...";

    const updateActiveFilter = (e) => {
        setActiveFilter(e.target.checked);
    }

    const HandleFilter = (e) => {
        setFilter(e.toLowerCase());
    };

    function filterUsers(user) {
        return user.lastName.toLowerCase().includes(filter) || user.firstName.toLowerCase().includes(filter) || user.email.toLowerCase().includes(filter);
    }


    const centerUsersCols = [
        { field: 'firstName', headerName: 'Firstname' },
        { field: 'lastName', headerName: 'Lastname' },
        { field: 'email', headerName: 'Email address', flex: 1 }
    ];

    return (
        <div>
            <div className="container">
                <div className="justify-content-end d-flex p-3 m-6">
                    <Filter
                        setSearchQuery={HandleFilter}
                        searchQuery={filter}
                        helper={searchBarHelper}
                        setActive={updateActiveFilter}
                        HideAddButton={true}
                    />
                </div>
            </div>
            {
                centerUsers ?
                    <Grid item xs={12} container sx={{ height: 300 }}>
                        <div style={{ height: 300, width: '100%' }}>
                            <DataGrid
                                rows={centerUsers
                                    .filter(filterUsers)
                                    .filter((u) => { return activeFilter ? false : u })
                                    .map((user => {
                                        return user;
                                    }))}
                                hideFooter
                                columns={centerUsersCols}
                                disableSelectionOnClick
                                rowsPerPageOptions={[]}
                                getRowClassName={(params) => {
                                    return `row-child-${(centerUsers.filter((params) => params.id == params.id)[0].active ? "active" : "inactive")}`
                                }}
                            />
                        </div>
                    </Grid> : <></>
            }

        </div>
    )
}

export default UsersTab;